export const siteConfig = {
  name: 'Auto Sens',
  baseUrl: 'https://autosens.fr',
  locale: 'fr_FR',
  defaultImage: '/assets/autosens-og-classic.webp',
  googleBusinessUrl: 'https://share.google/35PyET3MYzE6HneTC',
  consultationDate: '17 juillet 2026',
  advisor: {
    name: 'Enzo Chevallier',
    role: 'Conseiller automobile indépendant',
  },
} as const;

export type SeoData = {
  title: string;
  description: string;
  canonicalPath: string;
  image: string;
  imageAlt: string;
  preloadImage?: string;
  type: 'website' | 'article';
  publishedAt?: string;
  updatedAt?: string;
  articleSection?: string;
  robots?: string;
  structuredData: Record<string, unknown>[];
};
